




































































































import AdUnit from "@/models/adUnit";
import Campaign, { LineItem } from "@/models/campaign";
import Definition, { DefinitionList } from "@/models/definition";
import DefinitionValue from "@/models/definitionValue";
import { QueryParams } from "@/models/general";
import AdUnitsAPI from "@/services/adUnits";
import CampaignsAPI from "@/services/campaigns";
import { AvailabilityModule } from "@/store/availability";
import { LayoutModule } from "@/store/layout";
import { UserModule } from "@/store/user";
import CampaignHelper from "@/helpers/campaign";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import AvailabilityEntry from "./AvailabilityEntry.vue";
import DefinitionsHelper from "@/helpers/definitions";
import LineItemsHelper from "@/helpers/lineItems";

@Component({
  components: {
    AvailabilityEntry,
  },
})
export default class AvailabilityDetails extends Vue {
  @Prop({ default: null }) adUnitId!: string;
  @Prop({ default: () => [] }) lineItems!: LineItem[];
  @Prop({ default: () => [] }) campaigns!: Campaign[];
  @Prop({ default: () => [] }) definitions!: DefinitionList[];
  @Prop({ default: null }) environment!: Definition;
  @Prop({ default: null }) country!: string;

  adUnit: AdUnit = new AdUnit();
  futureLineItems: LineItem[] = [];
  pastLineItems: LineItem[] = [];
  panel = [0, 1];

  get filteredLineItems(): LineItem[] {
    let items = this.lineItems.filter((l) => l.adUnitId === this.adUnitId);

    items = this.country
      ? LineItemsHelper.filterLineItemsByDefinition(this.country, items)
      : items;

    return items;
  }

  get countryName(): string {
    const c = DefinitionsHelper.getDefinitionNameByType(
      this.country,
      "country",
      this.definitions
    );
    return c;
  }

  async created(): Promise<void> {
    await this.getAdUnit();
    await this.getFutureLineItems();
    await this.getPastLineItems();
  }

  async getAdUnit(): Promise<void> {
    const r = await AdUnitsAPI.get(this.adUnitId);
    this.adUnit = r;
  }

  async getPastLineItems(): Promise<void> {
    LayoutModule.showLoader();
    const yesterday = moment().subtract(1, "days").toDate();
    const params: QueryParams = {
      page: {
        size: -1,
      },
      filter: {
        site_id: AvailabilityModule.filter?.site_id,
        ad_units: this.adUnit.id,
        end: yesterday,
        definitions: this.environment.id,
      },
    };

    const r = await CampaignsAPI.lineItems.all(params);

    r.data.forEach((e) => {
      const l = this.filteredLineItems.find((f) => f.id === e.id);
      !l ? this.pastLineItems.push(e) : null;
    });

    this.pastLineItems = this.country
      ? LineItemsHelper.filterLineItemsByDefinition(
          this.country,
          this.pastLineItems
        )
      : this.pastLineItems;

    LayoutModule.hideLoader();
  }

  async getFutureLineItems(): Promise<void> {
    LayoutModule.showLoader();
    const tomorrow = moment().add(1, "days").toDate();
    const params: QueryParams = {
      page: {
        size: -1,
      },
      filter: {
        site_id: AvailabilityModule.filter?.site_id,
        ad_units: this.adUnit.id,
        start: tomorrow,
        definitions: this.environment.id,
      },
    };

    const r = await CampaignsAPI.lineItems.all(params);

    r.data.forEach((e) => {
      const l = this.filteredLineItems.find((f) => f.id === e.id);
      !l ? this.futureLineItems.push(e) : null;
    });

    this.futureLineItems = this.country
      ? LineItemsHelper.filterLineItemsByDefinition(
          this.country,
          this.futureLineItems
        )
      : this.futureLineItems;

    LayoutModule.hideLoader();
  }

  getCampaign(id: string): Campaign {
    const c = this.campaigns.find((e) => e.id === id);
    return c ? c : new Campaign();
  }

  getDefinitions(definitions: string[]): DefinitionValue[] {
    const d: DefinitionValue[] = [];

    this.definitions.forEach((e) => {
      e.values.forEach((v) => {
        definitions.includes(v.id ? v.id : "") ? d.push(v) : null;
      });
    });

    return d;
  }

  formatDate(date: Date): string {
    const d = moment(date).format("DD-MM-YYYY");
    return d;
  }

  goToCampaign(id: string): void {
    if (UserModule.isAdmin) {
      let routeData = this.$router.resolve({
        name: "edit-campaign",
        params: { id: id },
      });
      window.open(routeData.href, "_blank");
    }
  }

  close(): void {
    LayoutModule.hideRightDrawer();
  }

  campaignStatusColor(status: string): string {
    return CampaignHelper.getColorClass(status);
  }
}
